var _circle, _g, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 248,
    fill: "#6366f1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 256)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -100,
    r: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.6,
    cy: 50,
    r: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -86.6,
    cy: 50,
    r: 35,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -40,
    x2: 0,
    y2: -65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.6,
    y1: 20,
    x2: 52,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: -34.6,
    y1: 20,
    x2: -52,
    y2: 30
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 248,
    fill: "none",
    stroke: "rgba(0,0,0,0.1)",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3586916e5aa61ece243f799018c77e84.svg";
export { ForwardRef as ReactComponent };